export default __webpack_public_path__ + "static/media/linkdin_icon.92a00a85.svg";